import { pick } from 'lodash-es';

import AdminUserDocumentGroupFormSection from '../forms/AdminUserDocumentGroupFormSection';
import AdminAddUserStepTemplate from './AdminAddUserStepTemplate';
import { FormTheme } from '../../../../styles/formThemeConstants';

export default function AdminAddUserDocumentGroup({
  onSave,
  onBack,
  onCancel,
  values,
}) {
  return (
    <AdminAddUserStepTemplate
      titleId="admin.userManagement.addUser.documentGroup"
      titleIcon="file-alt"
      onSave={onSave}
      onBack={onBack}
      onCancel={onCancel}
      values={values}
      formClassName={FormTheme.DarkSimple}
      extractRelevantValues={vals => pick(vals, ['documentGroup'])}
    >
      <AdminUserDocumentGroupFormSection />
    </AdminAddUserStepTemplate>
  );
}
